// usePageTitle — sets the browser-tab title to "<page> · <brand>" while a page
// is mounted, layering on top of useBrandChrome's brand-only base title (see
// src/lib/useTenantBrand.ts, which anticipated this helper). Restores the brand
// base on unmount, so navigating to a page that doesn't set a title falls back
// to the brand name rather than inheriting a stale one.
//
// Usage — call once near the top of a page component:
//   usePageTitle('Spray records')
// Pass a falsy value to skip (e.g. while the page name is still loading).

import { useEffect } from 'react'
import { useTenantBrand } from '@/lib/useTenantBrand'

export function usePageTitle(title: string | null | undefined): void {
  const { appName } = useTenantBrand()
  useEffect(() => {
    if (title) document.title = `${title} · ${appName}`
    return () => { document.title = appName }
  }, [title, appName])
}
